import React from "react";

export const availableVariationTypes = {
  Any: "Any"
};

export const popupBlockerContent = {
  Any: {
    warningMessage: (
      <article>
        <h6 className="warningTitle">Your browser may have blocked pop-ups</h6>
        <p className="warningText">
          To download or view a document{" "}
          <strong>you will need to allow popups.</strong>
        </p>
        <p className="warningText">
          To enable popups, go to the settings on your web browser and find the
          popup option. Depending on the web browser you are using you may find
          this in site permissions or security section of settings.
        </p>
        <p className="warningText">
          Please refer to your online browser or device support pages for more
          information.
        </p>
      </article>
    )
  }
};
